import {
    takeEvery,
    put
} from 'redux-saga/effects';

import api from 'services/restApiHelper';
import SiteFacilitiesService from 'services/SiteFacilitiesService';
const baseUrl = process.env.REACT_APP_BASE_URL;

//tell eslint that Promise is a global var
/*global Promise */

export function* fetchSiteFacilitiesCatalogFlow(action) {
    try {
        const response = yield api.get(`${baseUrl}/sitefacilities`);
        yield put({
            type: SiteFacilitiesService.SITE_FACILITIES_CATALOG_FETCH_SUCCESS,
            response
        });
    } catch (error) {
        yield put({
            type: SiteFacilitiesService.SITE_FACILITIES_CATALOG_FETCH_ERROR,
            error
        });
    }
}

export function* watchSiteFacilitiesRequests() {
    yield takeEvery(SiteFacilitiesService.SITE_FACILITIES_CATALOG_FETCH_START, fetchSiteFacilitiesCatalogFlow);
}



// WEBPACK FOOTER //
// ./src/services/sagas/SiteFacilitiesServiceSagas.js